var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #111;\n      }\n\n      .st1 {\n        fill: #900020;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.5,35.9H10.5c-1,0-1.9-.4-2.5-1.1-.6-.6-.9-1.4-.9-2.3l.8-18.2c0-1.7,1.6-3.1,3.4-3.1h18.4c1.8,0,3.3,1.3,3.4,3.1l.8,18.2c0,.8-.3,1.7-.9,2.3-.6.7-1.6,1.1-2.5,1.1ZM11.3,13.3c-.8,0-1.4.5-1.4,1.2l-.8,18.2c0,.3.1.6.3.8.3.3.7.4,1.1.4h20c.4,0,.8-.2,1.1-.4.2-.2.3-.5.3-.8l-.8-18.2c0-.6-.6-1.2-1.4-1.2H11.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26,13.2c-.6,0-1-.4-1-1v-2.1c0-2.2-2-4-4.5-4s-4.5,1.8-4.5,4v2.1c0,.6-.4,1-1,1s-1-.4-1-1v-2.1c0-3.3,2.9-6,6.5-6s6.5,2.7,6.5,6v2.1c0,.6-.4,1-1,1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.5,21.9c-3.6,0-6.5-2.6-6.5-5.9s.4-1,1-1,1,.4,1,1c0,2.1,2,3.9,4.5,3.9s4.5-1.7,4.5-3.9.4-1,1-1,1,.4,1,1c0,3.2-2.9,5.9-6.5,5.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping);
export default __webpack_public_path__ + "static/media/shopping.52e4451697cae73f16d4073833324122.svg";
export { ForwardRef as ReactComponent };